<template>
    <div class="materialReport">
        <!-- <el-button type="primary" @click="getPdf('#pdfdom')">下载报告</el-button> -->
        <div class="btns">
            <el-button type="primary" @click="createPage">下载报告</el-button>
            <el-button type="primary" @click="back">返回</el-button>
        </div>
        <div class="dingmei">
            <div class="tops" id="top">
                <div class="top">
                    <div class="l">
                        <span class="l-t">天信公估</span>
                        <span class="l-b">TIANXIN  ADJUSTERS</span>
                    </div>
                    <div class="r">
                        委托编号:
                        <span class="r-r">{{caseNo}}号</span>

                    </div>
                </div>
            </div>
        </div>
        
        <div id="pdfdom" class="pdf">
            <div class="title">机动车辆保险调查委托函</div>
            
            <div class="content">
                <div class="item" style="height:250px">
                    <div class="p">
                        广州天信保险公估有限公司：
                    </div>
                    <div class="p p2em">
                        兹有<span class="span1"></span>
                        驾驶的我公司承保车辆<span class="span2"></span>
                        于<span class="span3"></span>
                        年<span class="span4"></span>
                        月<span class="span5"></span>
                        日<span class="span6"></span>
                        时在<span class="span7"></span>
                        <span style="text-indent: 0em;">发生碰撞，该车情况如下。请贵司代调查处理，</span>按照但不局限以下要求对案件进行调查处理，并请最终的调查报告以书面形式邮寄到我司：
                    </div>
                    <div class="p">
                       
                    </div>
                    <div class="p">
                       
                    </div>
                    <div class="p">
                        
                    </div>
                    <div class="p">
                        
                    </div>
                </div>
                <div class="item">
                    <div class="p" style="margin-top:10px">
                        保单号：
                    </div>
                    <div class="p">
                        被保人 ：
                    </div>
                    <div class="p">
                        事故号：
                    </div>
                    <div class="p">
                        车牌号： 
                    </div>
                    <div class="p">
                        厂牌型号：
                    </div>
                    <div class="p" style="margin-bottom:10px">
                        车架号：
                    </div>
                </div>

                <div class="item">
                    <div class="p">
                        事故经过、委托事项及要求：
                    </div>
                    <div class="p p2em">
                        委托贵司调查处理，经调查取得核心证据拒赔或减损按拒赔或核损金额
                        <span style="text-indent: 0em;">的</span>
                        <span class="span3"></span>
                        %提取奖励费用+基础费
                        <span class="span3" style="width:80px"></span>
                        。
                    </div>
                    <div class="p" style="margin-top:20px">
                        <span class="span1" style="width:50px"></span>财产保险股份有限公司<span class="span1" style="width:50px"></span>分公司
                    </div>
                    <div class="p">
                        联系人：
                    </div>
                    <div class="p">
                        联系电话：
                    </div>
                    <div class="p" style="margin-top:20px">
                        调查费用支付方式：公司转账
                    </div>
                    <div class="p p2em" style="margin-top:40px;margin-bottom:10px">
                        请将本调查委托函盖章回传，表示贵司接受本委托并受本函约束，谢谢合作！备注：请严格按照委托函内容进行工作，不得想其他机构几个人提供、兜售客户信息！
                    </div>
                </div>

                <div>
                    <div class="stamp">
                        <div class="stamp-item">
                            <div class="">被委托人盖章</div>
                            <div class="stamp-item-date">年  月  日</div>
                        </div>
                        <div class="stamp-item">
                            <div class="">委托人盖章</div>
                            <div class="stamp-item-date">年  月  日</div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>

        <div class="pages">
        </div>
        <div class="dingmeiimg"></div>

        <div class="backtop" @click="backTop">
            <i class="el-icon-top"></i>
        </div>
    </div>
</template>
<script>
import api from '../../../api/main'
import html2Canvas from 'html2canvas'
import store from '../../../store'

// import { provinceAndCityData , CodeToText } from "element-china-area-data";

export default {
    name: 'entrustMaterial',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            detail:{},
            page:1,
            htmlTitle:'价格评估委托准许书',
            scale:4,
            caseNo:'',
        }
    },
    created(){
        this.queryAssetsMaterialDamage();
    },
    mounted(){
        this.caseNo = this.$route.query.caseNo;
    },
    methods:{
        backTop(){
            document.querySelector('.el-main').scrollTop = 0

        },
        biaotou(){
            document.querySelector('.el-main').scrollTop = 0

            let _this = this;
            html2Canvas(document.getElementById('top'),{
                    backgroundColor: null, // 背景颜色
                    dpi: 192, // 将分辨率提高到特定的dpi,默认值为96
                    scale: this.scale, // 用于渲染的比例尺。默认为浏览器设备像素比率。默认值是1，手机端设置成2
                    useCORS:true, // 是否尝试使用CORS从服务器加载图像
                    scrollY: 0, 
                    scrollX: 0,
            }).then((canvas) => {
                _this.convertCanvasToImage(canvas);
            })
        },
        convertCanvasToImage(canvas) {
            // document.getElementById('top').remove();
            var imgStr = canvas.toDataURL("image/png");
            var img=new Image();
            img.src=imgStr;
            img.setAttribute('class', 'biaotou')
            document.querySelector('.dingmeiimg').append(img);
            this.getPdf('#pdfdom')
        },
        createPage(){
            this.page=1;
            store.dispatch('global/setLoading', true);
            var canvas = document.getElementById('pdfdom');
            var a4Width = 595.28;
            var a4Height = 701.89;
            var a4HeightRef = Math.floor((canvas.offsetWidth / a4Width) * a4Height)
            var p = canvas.offsetHeight/a4HeightRef;
            var pages = document.querySelector('.pages');
            for(let i = 0;i < p+1;i++){
                pages.innerHTML = pages.innerHTML + '<div class="page page'+this.page+'" style="width: 880px;font-size: 14px;text-align: center;">第'+this.page+'页</div>';
                this.pageToCanvas('page'+this.page);
                this.page = this.page+1;
            }

            this.biaotou();
        },
        pageToCanvas(page){
            console.log(page);
            let _this = this;
            html2Canvas(document.querySelector('.'+page),{
                    backgroundColor: null, // 背景颜色
                    dpi: 120, // 将分辨率提高到特定的dpi,默认值为96
                    scale: 1, // 用于渲染的比例尺。默认为浏览器设备像素比率。默认值是1，手机端设置成2
                    useCORS:true, // 是否尝试使用CORS从服务器加载图像
                    scrollY: 0, 
                    scrollX: 0,
            }).then((canvas) => {
                _this.pageCanvasToImage(canvas,page);
            })
        },
        pageCanvasToImage(canvas, className){
            var imgStr = canvas.toDataURL("image/png");
            var img=new Image();
            img.src=imgStr;
            img.setAttribute('class', 'img'+className)
            document.querySelector('.pages').append(img);
            // this.getPdf('#pdfdom')
        },
       
        async queryAssetsMaterialDamage(){
            
           
           
        },
        CNDateString(date){
            var cn = ["〇","一","二","三","四","五","六","七","八","九"];
            var s = [];
            var YY = date.getFullYear().toString();
            for (var i=0; i<YY.length; i++)
            if (cn[YY.charAt(i)])
            s.push(cn[YY.charAt(i)]);
            else
            s.push(YY.charAt(i));
            s.push("年");
            var MM = date.getMonth()+1;
            if (MM<10)
            s.push(cn[MM]);
            else if (MM<20)
            s.push("十" + cn[MM% 10]);
            s.push("月");
            var DD = date.getDate();
            if (DD<10)
            s.push(cn[DD]);
            else if (DD<20)
            s.push("十" + cn[DD% 10]);
            else if (DD<30)
            s.push("二十" + cn[DD% 10]);
            else
            s.push("三十" + cn[DD% 10]);
            s.push("日");
            return s.join('');
        },
        back(){
            this.$router.go(-1)
        },
        
       
        
    }
    
}
</script>

<style lang="scss" scoped>
   
    .materialReport{
        // font-family: 'simsun';
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 20px;
        .dingmei{
            margin-top: 20px;
        }
        .backtop{
            box-shadow: 0 4px 4px rgba(0,21,41,.1);
            width: 60px;
            height: 60px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: fixed;
            right: 50px;
            bottom: 100px;
            font-size: 36px;
            background-color: rgba(0, 0, 0, 0.2);
            color: #ffffff;
            cursor: pointer;
        }
        .tops{
            padding: 0 100px;
            // .biaotou{
            //     width: 880px;
            // }
        }
        .top{
            width: 680px;
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #000000;
            .l{
                display: flex;
                flex-direction: column;
                .l-t{
                    font-size: 24px;
                }
                .l-b{
                    font-size: 16px;
                    margin-top: 4px;
                }
            }
            .r{
                font-size: 24px;
                span{
                    color: red;
                    font-size: 18px;
                    text-decoration: underline;
                }
            }
        }
        .pdf{
            // border: 1px solid #000000;
            width: 680px;
            padding: 0 100px;
            .title{
                font-size: 28px;
                font-weight: bold;
                text-align: center;
                letter-spacing: 2px;
                line-height: 55px;
            }
            .content{
                border: 1px solid #000000;
                width: 100%;
                min-height: 680px;
                padding-top: 5px;
                .item{
                    border-bottom: 1px solid #000000;
                }
                .p{
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 20px;
                    line-height: 28px;
                    padding: 0 10px;
                    .span1{
                        width: 60px;
                        border-bottom: 1px solid #000000;
                    }
                }
                .p2em{
                    text-indent: 2em;
                    span{
                        display: block;
                        height: 24px;
                    }
                    .span1{
                        width: 60px;
                        border-bottom: 1px solid #000000;
                    }
                    .span2{
                        width: 60px;
                        border-bottom: 1px solid #000000;
                    }
                    .span3{
                        width: 35px;
                        border-bottom: 1px solid #000000;
                    }
                    .span4{
                        width: 35px;
                        border-bottom: 1px solid #000000;
                    }
                    .span5{
                        width: 35px;
                        border-bottom: 1px solid #000000;
                    }
                    .span6{
                        width: 35px;
                        border-bottom: 1px solid #000000;
                    }
                    .span7{
                        width: 230px;
                        border-bottom: 1px solid #000000;
                    }
                }
                .stamp{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    font-size: 20px;
                    padding-top: 80px;
                    .stamp-item{
                        display: flex;
                        flex-direction: column;
                        padding: 0 70px;
                        padding-bottom: 25px;
                        .stamp-item-date{
                            display: flex;
                            text-align: center;
                            letter-spacing: 8px;
                            margin-top: 4px;
                            width: 150px;
                        }
                    }
                }
            }
        }
        
    }
    .pages{
        width: 880px;
        .page{
            width: 880px;font-size: 14px;text-align: center;
            display: flex;
            justify-content: center;
        }
    }
</style>
